import _ from 'lodash'
import { Button, ResponsiveTable } from 'procyon-ui'
import React from 'react'
import { columns, useSessionLogsTable } from './SessionLogsTable.utils'

const SessionLogsTable = ({
  sessions = [],
  onLogClick,
  searchKey,
  nextPageTokens = {},
  isFetchingNextPage = false,
  onNextPage
}) => {
  const { rows } = useSessionLogsTable({ sessions, searchKey })

  const hasMore = Object.values(nextPageTokens).some((token) => token !== null)
  const lastLoadedPage = Math.ceil(rows.length / 15)
  const total = hasMore ? (lastLoadedPage + 1) * 15 : rows.length

  return (
    <div>
      <ResponsiveTable
        onRow={(data) => {
          return {
            onClick() {
              const SessionKey = data.id
              const log = _.find(sessions, { SessionKey })
              if (!log) return
              onLogClick(log)
            }
          }
        }}
        pagination={{
          pageSize: 15,
          total: total,
          showSizeChanger: false,
          itemRender: (page, type, originalElement) => {
            if (type === 'page' && page === lastLoadedPage + 1) {
              return null
            }
            if (type === 'next') {
              return (
                <button
                  className='ant-pagination-item-link !flex !items-center !justify-center !w-auto !px-3 !min-w-[20px]'
                  type='button'
                  onClick={(e) => {
                    if (hasMore) {
                      e.stopPropagation()
                      onNextPage()
                    }
                  }}
                  disabled={isFetchingNextPage || (!hasMore && rows.length <= 15)}
                >
                  {isFetchingNextPage ? 'Loading...' : 'Next >'}
                </button>
              )
            }
            return originalElement
          }
        }}
        showSizeChanger={false}
        columns={columns()}
        data={rows}
        scrollX='1200px'
      />
    </div>
  )
}

export { SessionLogsTable }
